import { useState, useEffect } from "react";
import { PostData } from "../../../types/blog.model";
import http from "../../../api/http-client";
import { useLocale } from "../../../context/LocaleContext";

export function usePost(blogSlug: string | undefined, postSlug: string | undefined) {
  const [post, setPost] = useState<PostData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { locale } = useLocale();

  useEffect(() => {
    if (!blogSlug || !postSlug) {
      // No slugs yet (e.g. index route) — nothing to load.
      setPost(null);
      setError(null);
      setLoading(false);
      return;
    }
    let isMounted = true;

    const fetchPost = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await http.get<PostData>(`/blog/${blogSlug}/${postSlug}`, {
          params: { locale },
        });
        const data = response.data;

        if (!isMounted) return;

        setPost(data);
      } catch (err) {
        if (!isMounted) return;
        setError(err instanceof Error ? err.message : 'An unknown error occurred');
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchPost();

    return () => {
      isMounted = false;
    };
  }, [blogSlug, postSlug, locale]);

  return { post, loading, error };
}